export const HEADER_ANNOUNCEMENT_ID = 'header-announcement';
